import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";

export class OpBnb extends VisualizerBase {
    constructor(_placeholderMode: boolean = false) {
        super("opBnb", _placeholderMode);
    }
    
    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        //this.appendBlendStyle(svg);
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const R = 40;
        const r0 = 100;
        const height = 40, halfH = height / 2;
        const pX = halfH * Math.tan(24 * Math.PI / 180);

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        const color1 = this.getColorHex(1, 2, 3);
        const color2 = this.getColorHex(4, 5, 6);
        const color3 = this.getColorHex(7, 8, 9);
        
        const idOB = `circleOutbounding_${this.chainIdName}`;
        const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
        const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
        obCircle.id = idOB;
        obCircle.setAttribute("d", `${dOB}`);
        defs.appendChild(obCircle);

        const idCircleBig = `circle_big_${this.chainIdName}`;
        const circleBig = SvgUtils.drawCircle0(idCircleBig, 0, -r0, R);
        defs.appendChild(circleBig);

        const points: Array<Point> = [ new Point(0, -r0 + halfH),
            new Point(-pX, -r0),
            new Point(0, -r0 - halfH),
            new Point(pX, -r0)
        ];
        const polygonId = `polygon_48deg_80_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        svg.appendChild(defs);

        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        // big-1
        this.addCircleUseToGroup(group, idCircleBig, null, null, null, ``, color1, "", 0);
        // big-2
        this.addCircleUseToGroup(group, idCircleBig, null, null, null, `rotate(120,0,0)`, color2, "", 0);
        // big-3
        this.addCircleUseToGroup(group, idCircleBig, null, null, null, `rotate(240,0,0)`, color3, "", 0);

        // small-1
        const color4 = this.getColorHex(10, 11, 12);
        this.addUsePartToGroup(group, polygonId, "rotate(60,0,0)", color4, "", 0);
        // // small-2
        const color5 = this.getColorHex(13, 14, 15);
        this.addUsePartToGroup(group, polygonId, "rotate(180,0,0)", color5, "", 0);
        // // small-3
        const color6 = this.getColorHex(16, 17, 18);
        this.addUsePartToGroup(group, polygonId, "rotate(300,0,0)", color6, "", 0);

        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);

        // sign
        const groupSign = document.createElementNS("http://www.w3.org/2000/svg", "g");
        const signColor = this.getColorHex(0, 10, 19);
        // width="21" height="24" viewBox="0 0 21 24"
        const signData = `M4.00392 3.6761L10.3727 0L16.7415 3.6761L14.4 5.03415L10.3727 2.7161L6.34539 5.03415L4.00392 3.6761ZM16.7415 8.31219L14.4 6.95415L10.3727 9.2722L6.34539 6.95415L4.00392 8.31219V11.0283L8.03123 13.3463V17.9824L10.3727 19.3405L12.7142 17.9824V13.3463L16.7415 11.0283V8.31219ZM16.7415 15.6644V12.9483L14.4 14.3063V17.0224L16.7415 15.6644ZM18.4039 16.6244L14.3766 18.9424V21.6585L20.7454 17.9824V10.6302L18.4039 11.9883V16.6244ZM16.0625 5.99415L18.4039 7.35219V10.0683L20.7454 8.71024V5.99415L18.4039 4.6361L16.0625 5.99415ZM8.03123 19.9259V22.642L10.3727 24L12.7142 22.642V19.9259L10.3727 21.2839L8.03123 19.9259ZM4.00392 15.6644L6.34539 17.0224V14.3063L4.00392 12.9483V15.6644ZM8.03123 5.99415L10.3727 7.35219L12.7142 5.99415L10.3727 4.6361L8.03123 5.99415ZM2.34146 7.35219L4.68293 5.99415L2.34146 4.6361L0 5.99415V8.71024L2.34146 10.0683V7.35219ZM2.34146 11.9883L0 10.6302V17.9824L6.36877 21.6585V18.9424L2.34146 16.6244V11.9883Z`;
        const sign = SvgUtils.createPath("", signData, false, signColor, "", 0);
        groupSign.appendChild(sign);
        groupSign.setAttribute("transform", `translate(129 120) scale(3)`);
        svg.appendChild(groupSign);
        return svg;
    }

}